// resources/react/pages/PagamentoResultado.tsx
import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';

const PagamentoResultado: React.FC = () => {
  const { pagamentoId, status: statusFromPath } = useParams<{
    pagamentoId: string;
    status: string;
  }>();

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [finalStatus, setFinalStatus] = useState<'success' | 'pending' | 'error'>('error');

  useEffect(() => {
    const statusQuery = searchParams.get('status')?.toLowerCase();
    const collectionStatus = searchParams.get('collection_status')?.toLowerCase();

    // Prioridade: query param do Mercado Pago > status da URL
    let statusToUse = statusFromPath?.toLowerCase();

    if (statusQuery === 'approved' || collectionStatus === 'approved') {
      statusToUse = 'success';
    } else if (statusQuery === 'pending' || collectionStatus === 'pending') {
      statusToUse = 'pending';
    } else if (statusQuery === 'rejected' || statusQuery === 'failed') {
      statusToUse = 'error';
    }

    if (statusToUse === 'success' || statusToUse === 'sucesso') {
      setFinalStatus('success');
    } else if (statusToUse === 'pending' || statusToUse === 'pendente') {
      setFinalStatus('pending');
    } else {
      setFinalStatus('error');
    }

    setIsLoading(false);
  }, [searchParams, statusFromPath]);

  const handleVoltar = () => navigate('/');
  const handleTentarNovamente = () => navigate('/pagamento'); // ajuste se necessário

  if (isLoading) {
    return <div style={{ padding: '40px', textAlign: 'center' }}>Carregando resultado...</div>;
  }

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f8fafc',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        padding: '48px 32px',
        maxWidth: '460px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 10px 30px rgba(0,0,0,0.08)'
      }}>
        {finalStatus === 'success' ? (
          <>
            <div style={{ fontSize: '72px', marginBottom: '20px' }}>✅</div>
            <h1 style={{ color: '#16a34a', marginBottom: '12px' }}>Pagamento Aprovado!</h1>
            <p style={{ fontSize: '18px', color: '#374151', marginBottom: '8px' }}>
              Seu pagamento foi realizado com sucesso.
            </p>
            {pagamentoId && <p><strong>ID:</strong> {pagamentoId}</p>}
          </>
        ) : finalStatus === 'pending' ? (
          <>
            <div style={{ fontSize: '72px', marginBottom: '20px' }}>⏳</div>
            <h1 style={{ color: '#ca8a04' }}>Pagamento em Processamento</h1>
          </>
        ) : (
          <>
            <div style={{ fontSize: '72px', marginBottom: '20px' }}>❌</div>
            <h1 style={{ color: '#ef4444' }}>Problema no Pagamento</h1>
            <p>Não foi possível confirmar o pagamento.</p>
            <button 
              onClick={handleTentarNovamente}
              style={{ margin: '20px 0', padding: '12px 28px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}
            >
              Tentar novamente
            </button>
          </>
        )}

        <button 
          onClick={handleVoltar}
          style={{ padding: '12px 28px', background: 'transparent', border: '1px solid #94a3b8', borderRadius: '8px', cursor: 'pointer' }}
        >
          Voltar para Início
        </button>
      </div>
    </div>
  );
};

export default PagamentoResultado;